// extracted by mini-css-extract-plugin
export var modal = "_56-0";